export default "__VITE_ASSET__9127f0d3__"